module.exports = __webpack_public_path__ + "img/add.6f4ff8c3.svg";